import { CheckoutSessionCriteria, LoanCriteria, OrderCriteria } from '@nemuru-eng/js-api-client';

import { GridDateTime } from '@/components/modules/_shared/utils/DataGridFields/GridDateTime';
import { Text } from '@/components/shared/components/Text';

export const createdAtFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.5,
    field: 'created_at',
    headerName: <Text tId={'CREATION_DATE'} />,
    align: 'right',
    type: 'number',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: { row: OrderCriteria | LoanCriteria | CheckoutSessionCriteria }) => {
      return <GridDateTime value={rowData.row.createdAt} />;
    },
  };
};
